import { gtmEvent } from '@/gtm/gtm-event';

export class GtmEvents {
  constructor(eventCategory) {
    this.eventCategory = eventCategory;
  }

  gtmEvent(data = {}) {
    return gtmEvent({
      eventCategory: this.eventCategory,
      ...data,
    });
  }

  crtoEvent(event, params = {}) {
    return gtmEvent({
      event,
      params: { crto: { ...params } },
    });
  }
}
